import { MonoBehavior } from 'game/core/monoBehavior';
import { Container, Graphics, Sprite } from 'pixi.js';
import gsap from 'gsap';

import { Layout } from 'game/LayoutManager';
import { getAsset, onAssetsLoad } from 'game/preloadGameAssets';
import { Store } from 'game/store/gameStore';

export class ShadowContainer extends MonoBehavior {
    container: Container;
    shadowSprite?: Sprite;
    shadowBorder: Graphics;
    constructor(parentContainer: Container) {
        super();
        this.redraw = this.redraw.bind(this);
        this.container = new Container();
        this.shadowBorder = new Graphics();
        parentContainer.addChild(this.container);
        parentContainer.addChild(this.shadowBorder);
        onAssetsLoad(this.draw.bind(this));
        this.visible(false);
    }
    async draw() {
        if (!Store.lowPerformanceDevice) {
            const txt = await getAsset('cards/shadow');
            this.shadowSprite = Sprite.from(txt);
            this.shadowSprite.anchor.set(0.5);
            this.container.addChild(this.shadowSprite);
        }
        this.redraw();
    }
    redraw() {
        if (!this.shadowSprite) return;
        if (!this.shadowBorder) return;
        try {
            this.shadowBorder.clear();
        } catch (error) {
            return;
        }

        const cardShadowSize = Layout.getShadowSize();
        const cardSize = Layout.getCardSize();
        this.shadowSprite.height = cardShadowSize.height;
        this.shadowSprite.width = cardShadowSize.width;
        if (!this.container.visible) return;
        this.shadowBorder.roundRect(
            -cardSize.width / 2,
            -cardSize.height / 2,
            cardSize.width,
            cardSize.height,
            cardSize.width / 10
        );
        this.shadowBorder.fill(0x565656);
        this.shadowBorder.alpha = 0.25;
        this.shadowBorder.position.y = 3;
    }
    visible(visible: boolean) {
        if (visible) {
            this.container.visible = true;
            gsap.to(this.container, { alpha: 1, duration: 0.3 });
        } else {
            this.container.visible = false;
            this.container.alpha = 0;
        }
    }
    resize(): void {
        this.redraw();
    }
}
